import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frameworkTranslations from '../framework/language/framework-translations';
import resources from './lang-resources';

// Merge both translation resources
const mergedResources = {
  en: {
    translation: resources.en.translation,
    framework: frameworkTranslations.en.translation
  },
  fa: {
    translation: resources.fa.translation,
    framework: frameworkTranslations.fa.translation
  },
  fad: {
    translation: resources.fad.translation,
    framework: frameworkTranslations.fad.translation
  },
  fap: {
    translation: resources.fap.translation,
    framework: frameworkTranslations.fap.translation
  }
};

// Initialize i18n with merged resources
i18n.use(initReactI18next).init({
  resources: mergedResources,
  lng: 'fa',
  fallbackLng: 'fa',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
